import type { Language } from "~/lib/api/types/verify";

/**
 * Returns the two-letter lowercase language code from the browser's preferred locale.
 */
export function getBrowserLanguageCode(): string {
    const lang = navigator.languages[0] ?? navigator.language;

    return lang.slice(0, 2).toLowerCase();
}

/**
 * Finds the app language matching the given language code, falling back to the default language.
 */
export function resolveChosenLanguage(
    languageCode: string,
    appLanguages: Language[],
    languageDefault: Language,
): Language {
    const match = appLanguages.find(
        (language) =>
            language.code.toLowerCase() === languageCode.toLowerCase(),
    );

    if (match) return match;

    return languageDefault;
}
